<script>
import { iBadge, iBadgeColours } from '@inscribe/signal';

const VerificationType = {
  EVIDENCE_OF_FRAUD: 'EVIDENCE_OF_FRAUD',
  INCONCLUSIVE: 'INCONCLUSIVE',
  EVIDENCE_OF_LEGITIMACY: 'EVIDENCE_OF_LEGITIMACY',
};

const BadgePropertiesEnum = {
  [VerificationType.EVIDENCE_OF_FRAUD]: {
    label: 'Evidence of Fraud',
    colour: iBadgeColours.ERROR,
    icon: 'small-alert-triangle',
  },
  [VerificationType.INCONCLUSIVE]: {
    label: 'Inconclusive',
    colour: iBadgeColours.WARNING,
    icon: 'small-alert-circle',
  },
  [VerificationType.EVIDENCE_OF_LEGITIMACY]: {
    label: 'Evidence of Legitimacy',
    colour: iBadgeColours.SUCCESS,
    icon: 'small-check-circle',
  },
};

export default {
  name: 'document-review-agent-verification',
  components: { iBadge },
  props: {
    index: {
      type: Number,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    result: {
      type: String,
      required: true,
    },
    rationale: {
      type: String,
      required: true,
    },
  },
  data() {
    return { iBadgeColours };
  },
  computed: {
    badgeProperties() {
      return BadgePropertiesEnum[this.result];
    },
  },
};
</script>

<template>
  <div
    class="verification-item d-flex flex-column align-items-start i-gap-4 i-pr-10"
    :class="{ 'has-border i-pt-9': index !== 0 }"
  >
    <div class="i-text-subheading-3 i-text-neutral-120">
      {{ title }}
    </div>
    <i-badge
      :colour="badgeProperties.colour"
      :icon="badgeProperties.icon"
      :label="badgeProperties.label"
      :has-leading-icon="true"
      :interactable="true"
    ></i-badge>
    <div class="i-text-body-3 i-text-neutral-120">
      {{ rationale }}
    </div>
  </div>
</template>

<style scoped lang="scss">
.verification-item.has-border {
  border-top: 1px solid $light-neutral-60;
}
</style>
